export default __webpack_public_path__ + "static/media/workplace.16d434b6.jpg";